export default __webpack_public_path__ + "9f7d21b5e51e16ad03a1f4e495dc3403.svg";